/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgHeartRate = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12.463 3a1 1 0 0 1 1.01.772l3.038 13.018 1.215-1.486.075-.082a1 1 0 0 1 .699-.285H22v2h-3.025l-2.2 2.695a1 1 0 0 1-1.749-.405l-2.332-9.994-1.706 10.92a1 1 0 0 1-1.936.163L7.64 16.082l-.369.471a1 1 0 0 1-.788.384H2v-2h3.997l1.215-1.554a1.001 1.001 0 0 1 1.736.3l.698 2.096 1.866-11.934a1 1 0 0 1 .95-.845z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgHeartRate as HeartRate };
